module.exports = __webpack_public_path__ + "static/media/04.a727d177.png";